import { isPlatformIs24 } from '@/helpers/Platform/Platform';
import { HgSupportedLanguage } from '@smg-real-estate/domus';
import {
  getHgCoreLinkAttributes,
  getHgCoreMetaProperties,
  getIs24CoreLinkAttributes,
  getIs24CoreMetaProperties,
} from '@smg-real-estate/metatags-seo';
import { type Link, type Meta } from '@unhead/vue';

export const getAppMetaInfo = (
  locale: HgSupportedLanguage,
): {
  htmlAttrs: {
    lang: string;
  };
  meta: Meta[];
  link: Link[];
} => ({
  htmlAttrs: {
    lang: locale,
  },
  meta: (isPlatformIs24()
    ? getIs24CoreMetaProperties()
    : getHgCoreMetaProperties()) as unknown as Meta[],
  link: (isPlatformIs24()
    ? getIs24CoreLinkAttributes()
    : getHgCoreLinkAttributes()) as unknown as Link[],
});

export const localizeLanguage = (locale: HgSupportedLanguage) => {
  return locale === HgSupportedLanguage.EN ? locale : `${locale}-CH`;
};
